import Box from "@mui/joy/Box";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import { Modal, ModalDialog } from "@mui/joy";

// ── Две картинки «как надо / как не надо» ──
// Положите свои два файла рядом с картинками онбординга и укажите пути тут
// (тот же приём, что в ModalOnboarding: относительный путь ./assets/onboarding/…).
const IMG_GOOD = "./assets/preview-good.png";  // как надо (без полей)
const IMG_BAD  = "./assets/preview-bad.png";   // как не надо (с полями)

export default function ModalPreviewHint({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose} sx={{ zIndex: 10020 }}>
      <ModalDialog
        variant="outlined"
        sx={{
          maxWidth: 460,
          width: "calc(100% - 32px)",
          borderRadius: "20px",
          p: 3,
          maxHeight: "90dvh",
          overflowY: "auto",
        }}
      >
        <Typography level="h4" sx={{ fontWeight: 800, mb: 0.5, textAlign: "center" }}>
          Важно: обрезка фотографий
        </Typography>

        <Stack direction="row" gap={1.5} sx={{ my: 2 }}>
          <Box sx={{ flex: 1, textAlign: "center" }}>
            <Box
              component="img"
              src={IMG_GOOD}
              alt="Как надо"
              sx={{
                width: "100%", borderRadius: "12px", display: "block",
                border: "2px solid var(--joy-palette-success-400)",
              }}
            />
            <Typography level="body-xs" sx={{ mt: 0.5, color: "success.600", fontWeight: 700 }}>
              ✓ Как надо
            </Typography>
          </Box>
          <Box sx={{ flex: 1, textAlign: "center" }}>
            <Box
              component="img"
              src={IMG_BAD}
              alt="Как не надо"
              sx={{
                width: "100%", borderRadius: "12px", display: "block",
                border: "2px solid var(--joy-palette-danger-400)",
              }}
            />
            <Typography level="body-xs" sx={{ mt: 0.5, color: "danger.600", fontWeight: 700 }}>
              ✗ Как не надо
            </Typography>
          </Box>
        </Stack>

        <Typography level="body-sm" sx={{ mb: 1.5 }}>
          Корешок уходит внутрь Фотокниги, если добавить скрин с чёрной полосой,
          он может быть виден при раскрытии.
        </Typography>
        <Typography level="body-sm" sx={{ mb: 1.5 }}>
          По трём сторонам, отмеченным жёлтой линией, фотография обрезается при
          печати. Жёлтая линия показывает ориентировочную границу обрезки —
          фактическая граница может отличаться примерно на ±3 мм от того, что вы
          видите на экране.
        </Typography>
        <Typography level="body-sm" sx={{ mb: 2 }}>
          Если добавить скриншот с чёрными полями, они могут попасть в область
          фотографии и после печати на вашей фотокниге появятся белые или чёрные
          края на листах.
        </Typography>

        <Button onClick={onClose} fullWidth sx={{ borderRadius: "12px", fontWeight: 700 }}>
          Ознакомлен(а)
        </Button>
      </ModalDialog>
    </Modal>
  );
}